import { render, staticRenderFns } from "./tab-overview.vue?vue&type=template&id=3b500569&"
import script from "./tab-overview.vue?vue&type=script&lang=js&"
export * from "./tab-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports